import React, { useRef, useState,useEffect } from "react";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import dayjs from "dayjs";

const DateRangeDropdown = ({ initialDates, onChange}) => {
  const [dates, setDates] = useState(null); // final applied dates
  const [tempFrom, setTempFrom] = useState(null); // temp from
  const [tempTo, setTempTo] = useState(null); // temp to
  const [customRange, setCustomRange] = useState(false);

  const op = useRef(null);
  const fromRef = useRef(null);
  const toRef = useRef(null);

  const today = dayjs();
 useEffect(() => {
    if (initialDates) {
      setDates([initialDates.startDate, initialDates.endDate]);
    }
  }, [initialDates]);
 const setPresetRange = (range) => {
  let from, to;
  switch (range) {
    case "today":
      from = to = today.toDate();
      break;
    case "yesterday":
      from = to = today.subtract(1, "day").toDate();
      break;
    case "last7":
      from = today.subtract(6, "day").toDate();
      to = today.toDate();
      break;
    case "last30":
      from = today.subtract(29, "day").toDate();
      to = today.toDate();
      break;
    case "thisMonth":
      from = today.startOf("month").toDate();
      to = today.toDate();
      break;
    default:
      return;
  }

  const newDates = [from, to];
  setDates(newDates);
  onChange && onChange({ startDate: from, endDate: to }); // <-- ADD THIS LINE
  setCustomRange(false);
  op.current.hide();
};


 const handleApply = () => {
    if (tempFrom && tempTo) {
      const newDates = [tempFrom, tempTo];
      setDates(newDates);
      onChange && onChange({ startDate: tempFrom, endDate: tempTo });
      op.current.hide();
    }
  };

   const handleReset = () => {
    setTempFrom(null);
    setTempTo(null);
    setCustomRange(false);
  };

  const formattedDate =
    dates && dates[0]
      ? `${dayjs(dates[0]).format("MMM DD, YYYY")} - ${dayjs(dates[1] || dates[0]).format("MMM DD, YYYY")}`
      : "";
  return (
    <div className="p-inputgroup">
      <input
        type="text"
        readOnly
        value={formattedDate}
        placeholder="Select Date"
        className="p-inputtext p-component"
        onClick={(e) => op.current.toggle(e)}
        style={{ cursor: "pointer", width: "300px" }}
      />
      <span className="p-inputgroup-addon" onClick={(e) => op.current.toggle(e)} style={{ cursor: "pointer" }}>
        <i className="pi pi-calendar"></i>
      </span>

      <OverlayPanel ref={op} style={{ width: "230px", padding: "0.5rem" }}>
        <div className="d-flex flex-column gap-2">
          <Button label="Today" style={{  fontSize: '12px', padding: '6px 5px' }} className="p-button-sm p-button-outlined w-100" onClick={() => setPresetRange("today")} />
          <Button label="Yesterday" style={{  fontSize: '12px', padding: '6px 5px' }} className="p-button-sm p-button-outlined w-100" onClick={() => setPresetRange("yesterday")} />
          <Button label="Last 7 Days" style={{  fontSize: '12px', padding: '6px 5px' }} className="p-button-sm p-button-outlined w-100" onClick={() => setPresetRange("last7")} />
          <Button label="Last 30 Days" style={{  fontSize: '12px', padding: '6px 5px' }} className="p-button-sm p-button-outlined w-100" onClick={() => setPresetRange("last30")} />
          <Button label="This Month" style={{  fontSize: '12px', padding: '6px 5px' }} className="p-button-sm p-button-outlined w-100" onClick={() => setPresetRange("thisMonth")} />
          <Button label="Custom Range" style={{  fontSize: '12px', padding: '6px 5px' }} className="p-button-sm p-button-outlined w-100" onClick={() => setCustomRange(true)} />
        </div>

        {customRange && (
          <div className="mt-3">
            <div className="mb-2">
              <label className="d-block mb-1" style={{ fontSize: '13px', fontWeight: 'bold' }}>FROM</label>
              <Calendar
                value={tempFrom}
                onChange={(e) => setTempFrom(e.value)}
                showIcon
                placeholder="Start Date"
                style={{ width: "100%" }}
                inputRef={fromRef}
              />
            </div>

            <div className="mb-3">
              <label className="d-block mb-1" style={{ fontSize: '13px', fontWeight: 'bold' }}>TO</label>
              <Calendar
                value={tempTo}
                onChange={(e) => setTempTo(e.value)}
                showIcon
                placeholder="End Date"
                style={{ width: "100%" }}
                inputRef={toRef}
              />
            </div>

            <div className="d-flex justify-content-between gap-2">
              <Button label="Apply" onClick={handleApply} className="p-button-sm p-button-primary w-100" style={{  fontSize: '12px', padding: '6px 5px' }}/>
              <Button label="Cancel" onClick={handleReset} className="p-button-sm p-button-secondary w-100" style={{  fontSize: '12px', padding: '6px 5px' }}/>
            </div>
          </div>
        )}
      </OverlayPanel>
    </div>
  );
};

export default DateRangeDropdown;
